<span *ngIf="refreshInterval">
  <span *ngIf="refreshText">{{refreshText}}</span>
  <span *ngIf="!refreshText">Auto Refreshing. Last refresh time:</span>
  <span>&nbsp;{{lastRefreshTime  | date:'hh:mm:ss' }}&nbsp;</span>
</span>
<button (click)="serverRefresh()" class="btn btn-success btn-sm" type="button">
  <bi name="arrow-clockwise"></bi>
  Refresh
</button>
